// Política de Cookies - Cookie Policy (ePrivacy Directive)
import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const CookiesPolicy = () => {
    return (
        <div className="legal-container">
            <nav className="legal-nav">
                <Link to="/" className="legal-back">← Volver al inicio</Link>
                <Link to="/" className="legal-logo">
                    <div className="legal-logo-icon">⚡</div>
                    <span className="legal-logo-text">Roadmap<span>Platform</span></span>
                </Link>
            </nav>

            <header className="legal-header">
                <h1>Política de Cookies</h1>
                <p className="legal-subtitle">Información sobre el uso de cookies en este sitio web</p>
                <span className="legal-updated">Última actualización: Febrero 2026</span>
            </header>

            <main className="legal-content">
                <section className="legal-section">
                    <h2>1. ¿Qué son las cookies?</h2>
                    <p>Las cookies son pequeños archivos de texto que los sitios web almacenan en su dispositivo (ordenador, tablet o móvil) cuando los visita. Se utilizan ampliamente para hacer que los sitios web funcionen de manera más eficiente y proporcionar información a los propietarios del sitio.</p>
                    
                    <div className="legal-info-box">
                        <p><strong>En términos simples:</strong> Las cookies son como pequeñas notas que el sitio web guarda en tu navegador para recordar cosas sobre ti, como que has iniciado sesión o tus preferencias.</p>
                    </div>
                </section>

                <section className="legal-section">
                    <h2>2. ¿Qué tipos de cookies utilizamos?</h2>
                    
                    <h3>2.1 Cookies estrictamente necesarias</h3>
                    <p>Estas cookies son esenciales para que pueda navegar por el sitio web y utilizar sus funciones. Sin estas cookies, servicios como el inicio de sesión no podrían funcionar.</p>
                    
                    <table className="legal-table">
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Propósito</th>
                                <th>Duración</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>sb-*-auth-token</td>
                                <td>Autenticación de sesión (Supabase)</td>
                                <td>1 semana</td>
                            </tr>
                            <tr>
                                <td>roadmap_session</td>
                                <td>Mantener la sesión del usuario</td>
                                <td>Sesión</td>
                            </tr>
                            <tr>
                                <td>cookie_consent</td>
                                <td>Recordar su elección de cookies</td>
                                <td>1 año</td>
                            </tr>
                        </tbody>
                    </table>

                    <h3>2.2 Cookies de preferencias</h3>
                    <p>Permiten que el sitio web recuerde información que cambia la forma en que se comporta o se ve, como su idioma preferido o la región en la que se encuentra.</p>
                    
                    <table className="legal-table">
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Propósito</th>
                                <th>Duración</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>roadmap_theme</td>
                                <td>Preferencia de tema (claro/oscuro)</td>
                                <td>1 año</td>
                            </tr>
                            <tr>
                                <td>roadmap_settings</td>
                                <td>Configuraciones de usuario</td>
                                <td>1 año</td>
                            </tr>
                        </tbody>
                    </table>

                    <h3>2.3 Cookies de rendimiento/análisis</h3>
                    <p>Recopilan información sobre cómo los visitantes utilizan el sitio web, por ejemplo, qué páginas visitan con más frecuencia. Utilizamos esta información para mejorar el sitio.</p>
                    
                    <table className="legal-table">
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Propósito</th>
                                <th>Duración</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>_vercel_insights</td>
                                <td>Análisis de rendimiento (Vercel)</td>
                                <td>1 año</td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="legal-info-box">
                        <p><strong>Nota:</strong> Actualmente NO utilizamos cookies de marketing/publicidad. No rastreamos su actividad para mostrarte anuncios personalizados.</p>
                    </div>
                </section>

                <section className="legal-section">
                    <h2>3. Cookies de terceros</h2>
                    <p>Algunos servicios de terceros que utilizamos pueden establecer sus propias cookies:</p>
                    
                    <h3>GitHub</h3>
                    <p>Cuando inicia sesión con GitHub, ellos pueden establecer cookies propias para gestionar la autenticación. Consulte la <a href="https://docs.github.com/en/site-policy/privacy-policies/github-cookies" target="_blank" rel="noopener noreferrer">política de cookies de GitHub</a>.</p>

                    <h3>Supabase</h3>
                    <p>Supabase establece cookies de sesión para la autenticación. Consulte la <a href="https://supabase.com/privacy" target="_blank" rel="noopener noreferrer">política de privacidad de Supabase</a>.</p>

                    <h3>Stripe</h3>
                    <p>Si realiza un pago, Stripe puede establecer cookies para prevenir fraudes. Consulte la <a href="https://stripe.com/es/privacy" target="_blank" rel="noopener noreferrer">política de privacidad de Stripe</a>.</p>
                </section>

                <section className="legal-section">
                    <h2>4. LocalStorage y SessionStorage</h2>
                    <p>Además de cookies, utilizamos tecnologías de almacenamiento del navegador:</p>
                    
                    <h3>LocalStorage</h3>
                    <p>Almacenamos datos en su navegador que persisten entre sesiones:</p>
                    <ul>
                        <li><strong>roadmap_data_*</strong>: Datos de sus proyectos (cacheados localmente)</li>
                        <li><strong>user_config</strong>: Su configuración de integaciones</li>
                        <li><strong>activity_log</strong>: Historial de actividad reciente</li>
                    </ul>
                    
                    <div className="legal-info-box warning">
                        <p><strong>Importante:</strong> Los datos sensibles como credenciales API NO se almacenan en localStorage sin cifrar. Utilizamos cifrado AES-256 para cualquier dato sensible almacenado localmente.</p>
                    </div>
                </section>

                <section className="legal-section">
                    <h2>5. Cómo gestionar las cookies</h2>
                    
                    <h3>5.1 A través de nuestro sitio</h3>
                    <p>Al visitar nuestro sitio por primera vez, verá un banner de consentimiento de cookies donde puede aceptar o rechazar las cookies no esenciales.</p>

                    <h3>5.2 A través de su navegador</h3>
                    <p>También puede gestionar las cookies a través de la configuración de su navegador:</p>
                    <ul>
                        <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
                        <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
                        <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
                        <li><a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
                    </ul>

                    <div className="legal-info-box important">
                        <p><strong>Atención:</strong> Si bloquea las cookies esenciales, algunas partes del sitio pueden no funcionar correctamente, incluyendo el inicio de sesión.</p>
                    </div>
                </section>

                <section className="legal-section">
                    <h2>6. Base legal</h2>
                    <p>Utilizamos cookies basándonos en:</p>
                    <ul>
                        <li><strong>Cookies esenciales:</strong> Interés legítimo (necesarias para el funcionamiento del servicio)</li>
                        <li><strong>Cookies de preferencias:</strong> Consentimiento del usuario</li>
                        <li><strong>Cookies de análisis:</strong> Consentimiento del usuario</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>7. Cambios en esta política</h2>
                    <p>Podemos actualizar esta Política de Cookies periódicamente. Le notificaremos cualquier cambio significativo publicando la nueva política en esta página y actualizando la fecha de "última actualización".</p>
                </section>

                <section className="legal-section">
                    <h2>8. Contacto</h2>
                    <p>Si tiene preguntas sobre nuestra Política de Cookies, puede contactarnos:</p>
                    <ul>
                        <li>Página de contacto: <Link to="/contact">roadmap.fixarr.es/contact</Link></li>
                        <li>Email: [EMAIL - PENDIENTE]</li>
                    </ul>
                </section>
            </main>

            <footer className="legal-footer">
                <div className="legal-footer-links">
                    <Link to="/legal">Aviso Legal</Link>
                    <Link to="/privacy-policy">Política de Privacidad</Link>
                    <Link to="/terms">Términos y Condiciones</Link>
                    <Link to="/contact">Contacto</Link>
                </div>
                <p>© 2026 Roadmap Platform. Parte del ecosistema FIXARR.</p>
            </footer>
        </div>
    );
};

export default CookiesPolicy;
